import offreAbonnementApi from '@/api/abonnement/offre-abonnement.api'

const getDefaultState = () => {
  return {
    offresAbonnement: [],
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    offresAbonnement (state) {
      return state.offresAbonnement
    },
  },
  mutations: {
    UPDATE_OFFRES_ABONNEMENT (state, offresAbonnement) {
      state.offresAbonnement = offresAbonnement
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    getAllOffreAbonnement ({commit }) {
      return offreAbonnementApi.getAllOffreAbonnement()
        .then(result => {
          commit('UPDATE_OFFRES_ABONNEMENT', result)
        })
    },
    getAllOffreAbonnementAdherent ({commit, rootGetters}) {
      const numtiers = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username

      return offreAbonnementApi.getAllOffreAbonnementByNumtiers(numtiers)
        .then(result => {
          commit('UPDATE_OFFRES_ABONNEMENT', result)
        })
    },
    updateOffreAbonnement ({ dispatch }, offreAbonnement) {
      return offreAbonnementApi.updateOffreAbonnement(offreAbonnement)
        .then(() => {
          dispatch('getAllOffreAbonnement')
        })
    },
    updateOffreAbonnementContenu ({ dispatch }, {offreID, contenuAbonnement}) {
      const promise = contenuAbonnement.id ? offreAbonnementApi.updateOffreAbonnementContenu(offreID, contenuAbonnement) : offreAbonnementApi.createOffreAbonnementContenu(offreID, contenuAbonnement)
      return promise
        .then(() => {
          dispatch('getAllOffreAbonnement')
        })
    },
    deleteOffreAbonnementContenu ({ dispatch }, contenuAbonnementID) {
      return offreAbonnementApi.deleteOffreAbonnementContenu(contenuAbonnementID)
        .then(() => {
          dispatch('getAllOffreAbonnement')
        })
    },
    reset ({ commit }) {
      commit('RESET')
    }
  }
}

export default module
